<button class="btn-block text-left font-weight-bold d-flex align-items-end" (click)="sort()">
  <ng-content></ng-content>
  <icon-sort class="ml-2 text-muted mb-1"
             [up]="current.direction === -1"
             [down]="current.direction === 1">
  </icon-sort>
</button>
